import { ReactNode } from 'react';

import { TwoPaneLayoutContainer } from './TwoPaneLayout.styled';

interface TwoPaneLayoutProps {
  children: ReactNode;
}

const TwoPaneLayout = ({ children }: TwoPaneLayoutProps) => {
  return <TwoPaneLayoutContainer>{children}</TwoPaneLayoutContainer>;
};

export default TwoPaneLayout;
